import axios from "axios";
import { API } from "@/lib/api";

/** Een groep of selectie opruimvoorstellen in een keer. Herstelbatch b (GO Frank 23 okt).
 *
 *  Eerst een token voor alle open voorstellen in `ids`, dan het besluit. De server
 *  verbruikt dat token per voorstel (WF-40), dus wat intussen al is afgehandeld wordt
 *  overgeslagen en geteld.
 */
export async function beslisGroep(ids, besluit) {
  const { data } = await axios.post(`${API}/postbus/geheugen-groep/toon`, { ids });
  const r = await axios.post(`${API}/postbus/geheugen-groep/${besluit}`, { ids, token: data.token });
  return r.data;
}

/** De open groepen in de lijst, met hun voorstel-id's. PUUR. */
export function openGroepen(berichten) {
  return (berichten || []).filter((b) => b.geheugen_groep).map((b) => ({ id: b.id, ids: b.geheugen_groep.ids }));
}
